<template>
  <div style="background:#f9f9f9;padding-bottom:50px;"> 

  
  <div data-v-7bc497ef="" class="index wrapper_1200">
    <div class="wrapper pact">
    <div class="slider-banner banner" v-if="picList.length>0"> 
            <swiper :options="swiperOption" ref="mySwiper"> 
                <swiper-slide
                  class="swiper-slide"
                  v-for="(item, index) in picList[0].content"
                  :key="index"
                  v-if="index < 10" 
                >
                  <img @click="jumpTap(item.url)" :src="item.pic_url" />
                </swiper-slide> 
              <div
                class="swiper-pagination paginationBanner"
                slot="pagination"
              ></div>
              <div class="swiper-button-prev" slot="pagination"></div>
              <div class="swiper-button-next" slot="pagination"></div>
            </swiper> 
        </div>
<div class="category acea-row row-middle" @mouseleave="leave()">
        <div class="sort">
          <div
            class="item acea-row row-between-wrapper"
            :class="index === current ? 'bg-color' : ''"
            v-for="(item, index) in categoryList"
            :key="index"
            v-if="index < 10"
            @mouseenter="enter(index)"
          >
            <div class="name line1">{{ item.name }}</div>
            <div class="iconfont icon-you"></div>
          </div>
        </div>
        <div class="sortCon" v-if="seen">
          <!--<div class="title">-->
          <!--<span class="font-color">{{ categoryCurrent.cate_name }}</span>-->
          <!--</div>-->
          <div class="erSort acea-row row-top">
            <div
              @click="goCate(categoryCurrent,item, index)"
              class="item acea-row row-middle"
              v-for="(item, index) in categoryCurrent.children"
              :key="index"
            >
              <div class="pictrue">
                <img v-lazy="item.pic_url" v-if="item.pic_url" />
                <img src="~@/assets/images/no_sort.jpg" alt="" v-else />
              </div>
              <div class="name line1">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
<div data-v-7bc497ef="" class="classify">
	<div data-v-7bc497ef="" class="list" :key="pindex" v-for="(pvalue,pindex) in pageList">


		<div data-v-7bc497ef="" class="title acea-row row-between-wrapper">
			<div data-v-7bc497ef="" class="name">{{pvalue.name}}</div>
			<!-- <a data-v-7bc497ef="" href="/goods_cate?cid=53&amp;cidIndex=0" class="more acea-row row-center-wrapper"> -->
				<!-- 更多<span data-v-7bc497ef="" class="iconfont icon-you"></span> -->
			<!-- </a> -->
		</div>


		<div data-v-7bc497ef="" class="acea-row row-middle"   >
			<div data-v-7bc497ef="" class="itemOne">
				<span data-v-7bc497ef="" href="#" class="more acea-row row-center-wrapper">
					<img data-v-7bc497ef="" :src="pvalue.content[0].pic_url">
				</span>
			</div>


			<div data-v-7bc497ef="" class="item" @click="jumpTap(goodsvalue.url)" :key="goodsindex" v-for="(goodsvalue,goodsindex) in pvalue.goodsList">
				<div data-v-7bc497ef="" class="pictrue">
					<img data-v-7bc497ef="" :src="goodsvalue.goods.pic_url">
				</div>
				<div data-v-7bc497ef="" class="money acea-row row-between-wrapper">
					<div data-v-7bc497ef="">
						<span data-v-7bc497ef="" class="font-color">¥{{goodsvalue.goods.orig_price}}</span>
						<span data-v-7bc497ef="" class="y_money">¥{{goodsvalue.goods.price_range[0]}}</span>
					</div>
					<!-- <div data-v-7bc497ef="" class="label font-color">
						券
					</div> -->
				</div>
				<div data-v-7bc497ef="" class="name line2">{{goodsvalue.goods.title}}</div>
				<div data-v-7bc497ef="" class="payment acea-row row-between-wrapper">
					<span data-v-7bc497ef="">{{ goodsvalue.goods.sold_count + goodsvalue.goods.sold_show_count }}人付款</span>
					<!-- <span data-v-7bc497ef="">4.6分</span> -->
				</div>
			</div>
  

	</div>


 

	</div> 
</div>

    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "IndexPc",
  components:{
    swiper,
    swiperSlide
  },
  data() {
    return { 

bannerList: [ 

],


      swiperOption: { 

        pagination: {
          el: ".paginationBanner",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      swiperScroll: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
      },
      swiperData:[
            {
                "id":1046,
                "title":"首页",
                "image":"https:\/\/demo26.crmeb.net\/uploads\/attach\/2022\/09\/20220908\/d67b32eeb54aef69b2b53f4bafa3f2f2.png",
                "url":"1"
            }
      ],
      serveAndApplyData: [ 
      ],
      sponsorData: [ 
      ],
      expertTutorData: [{ name: "特聘战略专家" }, { name: "爱心大导师" }],
      partnerArtData: [
        [
          { name: "艺术合作学校", class: "tab_active", type: 1 }
          // { name: "艺术特色学校", class: "", type: 2 },
        ],
        [
          { name: "艺术合作机构", class: "tab_active", type: 3 }
          // { name: "艺术推广中心", class: "", type: 4 },
        ]
      ],
      indexCateList: [ 
      ],
      indexCateListData: {
        萌想学院: [],
        通知公告: [],
        cutestarstar: [],
        // 萌星闪闪: [],
        国外影城一瞥: [],
        国际艺术节: [],
        艺术合作学校: [],
        艺术特色学校: [],
        艺术合作机构: [],
        艺术推广中心: [],
        服务导航与申报: [],
        特聘战略专家: [],
        爱心大导师: [],
        媒体合作伙伴: [],
        bannervideo: [],
        bannerurl: []
      },
      videoAction: false,
      // bannerLinkDataArr: [], //banner的四张图域
      cateDetailArr: {
        expert: "",
        tutor: ""
      },
      identityFlag: 0, //0 未登录 1 个人 2 单位
      trans: 0,
      setIntervalTime: null,
      
      seen: false,
      current: -1,
      picList:[],
      pageList:[],
      groupList:[],
      categoryList: [ ],
      categoryCurrent: {},
    };
  },
  mounted() {
    this.getIndexData(); 
  },
  computed: {},
  methods: {
    jumpTap(url){
      console.log('url',url)
      this.$router.push(url)
      return ;
    },
    enter(index) {
      this.seen = true;
      this.current = index;
      this.categoryCurrent = this.categoryList[index];
    },
    leave() {
      this.seen = false;
      this.current = -1;
    },
    move() {
      
      let that = this;
      that.trans=-1
      
      console.log(that.trans)
      console.log('执行move')

      // return;
      if (that.indexCateListData["艺术合作学校"].length > 0) {
        that.indexCateListData["艺术合作学校"].push(
          that.indexCateListData["艺术合作学校"][0]
        );
        that.indexCateListData['艺术合作机构'].push(
          that.indexCateListData['艺术合作机构'][0]
        );
        console.log('kaishi')
        that.setIntervalTime = setInterval(function() {
          that.trans -= 1;
          let _trans = that.trans * -1;

          if (_trans % 155 == 0) {
            // console.log(that.indexCateListData["艺术合作学校"]);
            let index=parseInt(_trans / 155)
            console.log(index)
            that.indexCateListData["艺术合作学校"].push(
              that.indexCateListData["艺术合作学校"][index]
            );
            that.indexCateListData["艺术合作机构"].push(
              that.indexCateListData["艺术合作机构"][index]
            );
          }
        }, 50);
        that.setIntervalTime;
      }
    },
    getidentityFlagFun() {
      if (localStorage.getItem("_token")) {
        this.$api.get("/api/index/userdata", {}, r => {
          if (r.data && r.data.is_danwei == 1) {
            //单位用户
            this.identityFlag = 1;
          } else {
            this.identityFlag = 2;
          }
        }),
        err => {
          console.log(err);
        };
      } else {
        this.identityFlag = 0;
      }
    },
    bannerClickFun(values) {
      console.log(values);
      this.$router.push({
        path: "/cmsdetail",
        query: { id: values.id }
      });
      return;
      if (values.extra_data.length) {
        for (let key in values.extra_data) {
          if (values.extra_data[key].field_key == "url") {
            window.location = values.extra_data[key].value;
            return;
          }
        }
      }
    },
    //获取关于我们 首页展示图的方法
    getOrganizationinfoFun() {
      this.$api.get(
        "/api/cms/catelist",
        {
          parent_id: 93, //93
          status: 1
        },
        res => {
          this.sponsorData = res.data;
        },
        r => {
          this.$message.error(r.msg);
        }
      );
    },
    //立即申请点击事件
    applyRightNowFun(val) {
      console.log("item", val);
      val.some(item => {
        if (item.class == "tab_active") {
          this.$router.push({
            path: "/danwei-apply-form",
            query: { type: item.type }
          });
        }
      });
    },
    goFuwu(item) {
      this.$router.push(item.url);
    },
    //处理 特聘战略专家+爱心大导师 点击事件
    handleTeacherClickFun(id) {
      // console.log(id)
      this.$router.push({ path: "/contentsinglepage", query: { id: id } });
    },
    //处理video点击事件
    handlevideoAction() {
      this.videoAction = !this.videoAction;
      if (!this.videoAction && this.$refs.myVideo) {
        setTimeout(() => {
          this.$refs.myVideo.pause();
          this.$refs.myVideo.currentTime = 0;
        }, 600);
      } else {
        if (this.$refs.myVideo) {
          this.$refs.myVideo.play();
        }
      }
    },
    //4栏目点击事件
    sponsorClickFun(val) {
      this.$router.push({ path: "/cate", query: { id: val.id } });
    },
    //初始化页面 获取内容
    getIndexData() {
      let that = this;
      this.$api.get(
        "/api/goods/cateTree",
        { 
        },
        res => {
          that.categoryList = res.data; 
        },
        err => {
          console.log(err);
        }
      );
      this.$api.get(
        "/api/index/contentList",
        { 
          business_id:1
        },
        res => {
          that.picList = res.data.filter(item =>{
            return item.type =='slidePics'
          })   
          let groupList = [];
          groupList = res.data.filter(item =>{
            return item.type =='pic'
          })   
          let goodsList = [];
          goodsList = res.data.filter(item =>{
            return item.type =='goodsList2'
          })   
          groupList.map((item,key) =>{
            if(typeof goodsList[key] =='undefined'){
              item.goodsList = []
            }else{
              item.goodsList = goodsList[key].content
            }
            return item;
          })
          that.pageList = groupList
        },
        err => {
          console.log(err);
        }
      );
 
    },
    //处理萌星闪闪的列表数据
    handlecuteStarList() {
      this.$api.get(
        "/api/cms/cuteStarapplyList",
        {
          pageNo: 1,
          pageSize: 15,
          status: 6,
          sort: "id",
          order: "desc",
          type: 2
        },
        res => {
          this.indexCateListData["cutestarstar"] = [];
          this.indexCateListData["cutestarstar"] = res.data.list;
        },
        err => {
          console.log(err);
        }
      );
    },
    //获取“单位”(danwei)页面内容
    //type 1 艺术合作学校/ 2艺术特色学校 /3艺术合作机构/ 4艺术推广中心
    getPositionData(type) {
      const that = this;
      that.$api.get(
        "/api/danwei/danweiList",
        {
          type: type
        },
        res => {
          // this.$message.success("发送成功");
          // console.log("danwei", res);
          switch (type) {
            case 1:
              this.indexCateListData["艺术合作学校"] = res.data.list;
              if(this.indexCateListData["艺术合作学校"].length > 0 && this.indexCateListData["艺术合作机构"].length > 0){
                that.move();
          }
              break;
            case 2:
              this.indexCateListData["艺术特色学校"] = res.data.list;
              break;
            case 3:
              this.indexCateListData["艺术合作机构"] = res.data.list;  
              if(this.indexCateListData["艺术合作学校"].length > 0 && this.indexCateListData["艺术合作机构"].length > 0){
                that.move();
          }
              break;
            case 4:
              this.indexCateListData["艺术推广中心"] = res.data.list;
              break;
          }
          

        },
        r => {
          that.$message.error(r.msg);
        }
      );
    },
    //学校点击事件
    schoolItemClickFun(val) {
      this.$router.push({
        name: "CmsPosition",
        query: { cmspositionId: val.id }
      });
    },
    // 艺术合作学校+艺术推广中心
    partnerAndArtMore(val) {
      val.some(item => {
        if (item.class == "tab_active") {
          // console.log(item);
          this.$router.push({
            path: "/organizationlist",
            query: { type: item.type }
          });
          return;
        }
      });
    },
    //国外影城一瞥/国际艺术节
    filmOrArtfun(id, name) {
      this.$router.push({
        path: "/foreignfilm",
        query: { id: id, name: name }
      });
    },
    //萌星闪闪 更多  点击事件
    cuteStarStarMoreFun() {
      // console.log("萌星闪闪 更多");
      this.$router.push({ path: "/cutestar" });
    },
    //通知公告 item点击事件
    infoPublishFun(val) {
      // console.log(val);
      this.$router.push({ path: "/cmsdetail", query: { id: val.id } });
    },
    //新闻公告更多
    infoPublishMoreFun() {
      this.$router.push({ path: "/cate", query: { id: 115 } });
    },
    //萌想学院 更多 点击事件
    cuteInstituteMoreFun() {
      this.$router.push({ path: "/cmslist", query: { id: 114 } });
    },
    //萌想学院item点击事件
    cuteInstituteFun(val) {
      // console.log(val)
      this.$router.push({ path: "/cmsdetail", query: { id: val.id } });
    },
    //处理tab 点击显示切换
    partnerArtTabClick(index1, index2) {
      this.partnerArtData[index1].some(item => {
        item.class = "";
      });
      this.partnerArtData[index1][index2].class = "tab_active";
      // console.log(
      //   "this.partnerArtData[index1].title[index2]",
      //   this.partnerArtData[index1]
      // );
    },
    openCourseFun() {
      this.$router.push({ path: "/cate", query: { id: "course-20" } });
    },
    goCate(top,sub){
      this.$router.push({ path: "/goodslist", query: { cate_id: top.id,sub_cate_id:sub.id } });
    },
    //通过cate_id 获取后端的数据 cate_id-》分类id  step-》每次获取的条数
    getInfoByCateid(cate_id, step, Catename) {
      const that = this;
      that.$api.get(
        "/api/cms/helpList",
        {
          cate_id: cate_id, //94表示全部
          step: step,
          status: 1
        },
        res => {
          // this.$message.success("发送成功");
          // that.MemberList = res.data.list;
          // console.log("indexCateListData---",this.indexCateListData)
          that.indexCateListData[Catename] = res.data.list;
        },
        r => {
          that.$message.error(r.msg);
        }
      );
    },
    //cate  根据父级找到子集
    // http://api.eaechina.net/api/cms/catelist?parent_id=93
    // getChildCateFun(parent_id) {
    //   const that = this;
    //   that.$api.get(
    //     "/api/cms/catelist",
    //     {
    //       parent_id: parent_id,
    //     },
    //     (res) => {
    //       if (parent_id == 156) {
    //         //banner  域的cate   parent_id
    //         this.bannerLinkDataArr = res.data;
    //         this.bannerLinkDataArr.some((item) => {
    //           if (item.url) {
    //             item.url = eval("(" + item.url + ")");
    //           }
    //         });
    //       }
    //     },
    //     (r) => {
    //       that.$message.error(r.msg);
    //     }
    //   );
    // },
    getCateDetail(cate_id) {
      this.$api.get(
        "/api/cms/cateListItem",
        { id: cate_id },
        res => {
          //res.data[0]
          // console.log(res);
          if (res.data.length) {
            if (cate_id == 123) {
              this.cateDetailArr["expert"] = res.data[0];
            }
            if (cate_id == 124) {
              this.cateDetailArr["tutor"] = res.data[0];
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  filters: {
    getCityForm(val) {
      return val.split("-")[1];
    }
  },
  destroyed(){
    clearInterval(this.setIntervalTime)

    this.setIntervalTime=null
    console.log(this.setIntervalTime)
  }
};
</script>
<style scoped lang="scss">
.banner_area {
  width: 100%;
  background: #e5eeff;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.fashion_show_area {
  margin-top: -2px;
  background: #ffebe1;
  position: relative;
  // overflow: hidden;
  height: 475px;
  width: 100%;
  .fashion_show_area_bg_wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    overflow: hidden;
    .fashion_show_area_bg {
      position: absolute;
      top: -110px;
      z-index: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 1441px;
      height: 450px;
      background: url("~@/assets/images/listitem/Group 455.png") no-repeat
        center center;
      background-size: 100% 100%;
    }
  }

  .fashion_show_area_children {
    position: absolute;
    z-index: 10;
    height: 269px;
    width: 1249px;
    background: url("~@/assets/images/listitem/Group474.png") no-repeat center
      center;
    background-size: cover cover;
    left: 49%;
    bottom: 5px;
    transform: translateX(-50%);
  }
  .fashion_show_area_pic {
    position: absolute;
    z-index: 20;
    height: 485px;
    width: 833px;
    // background: url("~@/assets/images/listitem/Group 345.png") no-repeat center
    //   center;
    // background-size: 100% 100%;
    left: 50%;
    transform: translateX(-53%);
    top: -50px;
    overflow: hidden;
    border-radius: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    video {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    img {
      height: 100%;
      width: 101%;
      object-fit: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      object-fit: cover;
    }
    .fashion_show_area_pic_action {
      width: 118px;
      height: 118px;
      background: url("~@/assets/images/listitem/组-7.png") no-repeat center
        center;
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      &:hover {
        cursor: pointer;
        opacity: 0.9;
      }
    }
    .fashion_show_area_pic_font {
      position: absolute;
      bottom: 32px;
      left: 32px;
      font-size: 24px;
      color: #ffffff;
      .fashion_show_area_pic_title {
      }
      .fashion_show_area_pic_date {
        font-size: 18px;
        margin-top: 7px;
      }
    }
  }
}
/deep/.child_class {
  // height: 583px;
  height: 450px;
  // line-height: 583px;
  background: #5e89f9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  .el-carousel {
    width: 100%;
  }
  .el-carousel__item {
    // color: #475669;
    // font-size: 14px;
    // opacity: 0.75;
    // line-height: 150px;
    // width: 1240px;
    // margin: 0;
    text-align: center;
    // line-height: 583px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  // .el-carousel__item:nth-child(2n) {
  //    background-color: #99a9bf;
  // }

  // .el-carousel__item:nth-child(2n+1) {
  //    background-color: #d3dce6;
  // }
  img {
    // width: 1240px;
    // height: 230px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: inline-block;
    cursor: pointer;
  }
  // img {
  //   width: 1240px;
  //   height: 90px;
  //   object-fit: cover;
  //   &:hover {
  //     cursor: pointer;
  //   }
  // }
  // .child_class_down {
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: space-between;
  //   width: 1240px;
  //   margin-top: 8px;
  //   img {
  //     height: 100px;
  //     width: 405px;
  //     object-fit: cover;
  //     &:hover {
  //       cursor: pointer;
  //     }
  //   }
  // }
}
.course_and_test {
  height: 159px;
  background: #ffeae1;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  font-size: 30px;
  color: #ffffff;
  .course_and_test_pic {
    width: 520px;
    height: 155px;
    line-height: 155px;
    text-align: center;
    background: url("~@/assets/images/listitem/Group 475.png") center center
      no-repeat;
    background-size: 100% 100%;
    &:nth-child(2) {
      margin-left: 193px;
      background: url("~@/assets/images/listitem/Group 476.png") center center
        no-repeat;
      background-size: 100% 100%;
    }
    &:hover {
      font-weight: bold;
      cursor: pointer;
      opacity: 0.9;
    }
  }
}
.school_and_notice {
  background: #e5eeff;
  .container_wrap {
    width: 1240px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  // 公共title
  .area_title {
    width: 100%;
    padding-top: 19px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    .area_title_left {
      width: 300px;
      color: #1981ff;
      font-size: 24px;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      position: relative;
      .area_title_left_name {
        border-bottom: 1px solid #1981ff;
        padding-right: 12px;
      }
      .area_title_left_ein {
        position: absolute;
        left: 103px;
        width: 60px;
        height: 20px;
        background: url("~@/assets/images/listitem/Group 488.png") no-repeat
          center center;
        background-size: cover cover;
        bottom: -1px;
      }
    }
    .area_title_right {
      // width: 140px;
      text-align: right;
      color: #1981ff;
      &:hover {
        cursor: pointer;

        font-weight: bold;
      }
    }
  }
  .school_area {
    width: 627px;
    .area_title {
      .area_title_left {
        .area_title_left_ein {
          width: 92px;
          left: 125px;
        }
      }
    }
    .area_wrap {
      padding-top: 24px;
      .area_wrap_item {
        display: flex;
        flex-direction: row;
        border-radius: 6px 0 0 6px;
        margin-bottom: 16px;
        transition: all 0.2s;
        &:hover {
          transform: scale(1.01);
          cursor: pointer;
        }
        .area_wrap_item_pic {
          width: 90px;
          height: 90px;
          border-radius: 6px 0 0 6px;
          // background: url("~@/assets/images/listitem/矩形.png") no-repeat center
          //   center;
          // background-size: 100% 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .area_wrap_item_content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 8px 0 8px 16px;
          box-sizing: border-box;
          background: #ffffff;
          .area_wrap_item_content_title {
            width: 510px;
            // height: 48px;
            font-size: 16px;
            color: #333333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              margin: 0 3px 0 5px;
              color: #1981ff;
              font-weight: bold;
            }
          }
          .area_wrap_item_content_desc {
            width: 510px;
            color: #9b9b9b;
            // height: 42px;
            // line-height: 21px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            // overflow: hidden;
            // display: -webkit-box;
            // -webkit-line-clamp: 2;
            // -webkit-box-orient: vertical;
          }
          .area_wrap_item_content_tip {
            display: flex;
            flex-direction: row;
            font-size: 12px;
            line-height: 14px;
            color: #999999;
            .area_wrap_item_content_tip_people {
              height: 17px;
              line-height: 17px;
              display: flex;
              flex-direction: row;
              margin-right: 32px;
              .area_wrap_item_content_tip_people_icon {
                width: 12px;
                height: 17px;
                background: url("~@/assets/images/listitem/Vector.png")
                  no-repeat center center;
                background-size: 100% 100%;
                margin-right: 8px;
              }
              .area_wrap_item_content_tip_people_date {
              }
            }
          }
        }
      }
    }
  }
  .notice_area {
    width: 581px;
    .area_title {
      .area_title_left {
        .area_title_left_ein {
          background: url("~@/assets/images/listitem/Group 491.png") no-repeat
            center center;
          background-size: 100% 100%;
        }
      }
    }
    .area_wrap {
      width: 581px;
      height: 409px;
      background: #ffffff;
      margin-top: 24px;
      padding-top: 9px;
      padding-left: 16px;
      overflow: hidden;
      box-sizing: border-box;
      .area_wrap_item {
        width: 100%;
        margin-bottom: 13px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        transition: all 0.2s;
        &:hover {
          transform: scale(1.01);
          cursor: pointer;
        }
        .area_wrap_item_date {
          width: 39px;
          height: 19px;
          line-height: 19px;
          text-align: center;
          font-size: 12px;
          color: #ffffff;
          background: url("~@/assets/images/listitem/Rectangle 25.png")
            no-repeat center center;
          background-size: 100% 100%;
          margin-top: 3px;
        }
        &:nth-child(n + 3) {
          .area_wrap_item_date {
            background: url("~@/assets/images/listitem/Rectangle 25 (1).png")
              no-repeat center center;
            background-size: 100% 100%;
          }
        }
        .area_wrap_item_content {
          width: 449px;
          height: 64px;
          margin-left: 8px;
          .area_wrap_item_content_title {
            width: 510px;
            font-size: 16px;
            color: #000;
            // display: -moz-box;
            // line-clamp: 1;
            // -webkit-box-orient: vertical;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 21px;
            span {
              margin: 0 3px 0 5px;
              color: #1981ff;
              font-weight: bold;
            }
          }
          .area_wrap_item_content_desc {
            // width: 510px;
            width: 449px;
            color: #9b9b9b;
            height: 42px;
            line-height: 21px;
            // overflow: hidden;
            // display: -webkit-box;
            // -webkit-line-clamp: 2;
            // -webkit-box-orient: vertical;

            // text-overflow: -o-ellipsis-lastline;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // -webkit-line-clamp: 2;
            // line-clamp: 2;
            // -webkit-box-orient: vertical;

            display: -webkit-box;
            display: -moz-box;
            display: box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
  }
}

.cute_film_art {
  background: #ffeae1;
  // padding-bottom: 38px;
  box-sizing: border-box;
  .container_wrap {
    width: 1240px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
  }
  .area_title {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: #1981ff;
    font-size: 24px;
    margin: 30px 0 32px 0;
    box-sizing: border-box;
    .area_title_name {
      &:hover {
        cursor: pointer;
      }
    }
    .area_title_more {
      font-size: 14px;
      &:hover {
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .cute_area {
    width: 620px;
    margin-right: 38px;
    .area_content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      overflow: hidden;
      // justify-content: space-between;
      .area_content_item {
        width: 100px;
        margin-bottom: 8px;
        transition: all 0.3s;
        margin-right: 29px;
        &:nth-child(5n) {
          margin-right: 0;
        }
        &:hover {
          cursor: pointer;
          transform: scale(1.03);
          .area_content_item_pic {
            .area_content_item_pic_size_wrap {
              opacity: 1;
              .area_content_item_pic_stature {
                // opacity: 1;
                // transition: opacity 0.2s linear;
              }
              .area_content_item_pic_weight {
                // transition: opacity 0.2s linear;
              }
            }
          }
        }
        .area_content_item_pic {
          width: 100px;
          height: 100px;
          border-radius: 4px;
          overflow: hidden;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .area_content_item_pic_size_wrap {
            position: absolute;
            bottom: 0;
            opacity: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            box-sizing: border-box;
            padding: 4px;
            background: rgba(0, 0, 0, 0.7);
            .area_content_item_pic_stature {
              color: #ffffff;
              font-size: 10px;
              // background-image: linear-gradient(
              //   to bottom,
              //   rgba(255, 255, 255, 0),
              //   rgba(0, 0, 0, 0.1)
              // );
            }
            .area_content_item_pic_weight {
              color: #ffffff;
              font-size: 10px;
              // background-image: linear-gradient(
              //   to bottom,
              //   rgba(255, 255, 255, 0),
              //   rgba(0, 0, 0, 0.7)
              // );
            }
          }
        }
        .area_content_item_name {
          font-size: 15px;
          color: #333333;
          text-align: center;
          line-height: 18px;
          margin-top: 8px;
          width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  //国外影城一瞥、国际艺术节相似内容区域
  .film_art_area_content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 399px;
    .area_content_item {
      width: 204px;
      height: 68px;
      // height: 56px;
      line-height: 68px;
      display: flex;
      flex-direction: row;
      align-items: center;
      background: linear-gradient(90deg, #ff8d3a 0%, #ffeae1 94.67%);
      // border-radius: 32px 0px 0px 32px;
      border-radius: 48px 0px 0px 48px;
      transition: all 0.2s;
      &:hover {
        cursor: pointer;
        transform: scale(1.01);
        font-weight: bold;
      }
      .area_content_item_pic {
        // width: 40px;
        // height: 40px;
        width: 48px;
        height: 48px;
        // border-radius:24px;
        // border-radius: 20px;
        border-radius: 24px;
        overflow: hidden;
        margin-left: 12px;
        margin-right: 10px;
        img {
          // width: 100%;
          // height: 100%;
          width: 48px;
          height: 48px;
          object-fit: cover;
        }
      }
      .area_content_item_name {
        font-size: 16px;
        width: 140px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .film_area {
    // width: 210px;
    width: 280px;
    margin-right: 24px;
    background: #ffffff;
    border: 1px solid #fb7b1c;
    box-sizing: border-box;
    padding: 0 57px 38px 18px;
    .area_title {
      align-items: flex-end;
    }
  }
  .art_area {
    width: 280px;
    // margin-right: 93px;
    background: #ffffff;
    border: 1px solid #fb7b1c;
    box-sizing: border-box;
    padding: 0 57px 38px 18px;
    .area_title {
      align-items: flex-end;
    }
  }
}

.partner_art {
  background: #e5eeff;
  .container_wrap {
    width: 1240px;
    margin: 0 auto;
    padding-bottom: 24px;
    box-sizing: border-box;
  }
  .area_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 24px 0;
    box-sizing: border-box;
    .area_header_left {
      display: flex;
      flex-direction: row;
      align-items: center;
      .area_header_left_tab {
        font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
          "\5FAE\8F6F\96C5\9ED1";
        font-size: 24px;
        color: #999999;
        margin-right: 48px;
        span {
          &:hover {
            color: #1981ff;
            cursor: pointer;
          }
        }
        .tab_active {
          color: #1981ff;
        }
      }
      .area_header_applybtn {
        width: 104px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 32px;
        background: #1981ff;
        font-size: 14px;
        color: #ffffff;
        &:hover {
          font-weight: bold;
          cursor: pointer;

          opacity: 0.9;
        }
      }
    }
    .area_header_more {
      color: #1981ff;
      font-size: 12px;
      &:hover {
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .area_content {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    // justify-content: space-between;
    .area_content_item {
      min-height: 172px;
      width: 145px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      color: #333333;
      margin-right: 10px;
      transition: all 0.2s;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        cursor: pointer;

        transform: scale(1.02);
      }
      .area_content_item_pic {
        width: 145px;
        height: 120px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
        }
      }
      .area_content_item_site {
        color: #666666;
        margin-top: 10px;
      }
      .area_content_item_name {
        width: 145px;
        text-align: center;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        // display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        font-weight: bold;
      }
    }
  }
}

.serve_apply {
  background: #5e89f9;
  overflow: hidden;
  .container_wrap {
    width: 1240px;
    margin: 0 auto;
    padding-bottom: 27px;
    padding-top: 31px;
    box-sizing: border-box;
  }
  .serve_apply_title {
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-size: 24px;
    color: #ffffff;
  }
  .serve_apply_content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 27px;
    .serve_apply_content_item {
      width: 232px;
      height: 130px;
      position: relative;
      margin-bottom: 13.6px;
      transition: all 0.2s;
      &:hover {
        cursor: pointer;

        transform: scale(1.02);
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 8px;
        object-fit: cover;
      }
      .serve_apply_content_item_title {
        position: absolute;
        top: 10px;
        left: 108px;
        font-size: 18px;
        color: #d77253;
      }
      .serve_apply_content_item_desc {
        position: absolute;
        top: 39px;
        left: 108px;
        font-size: 12px;
        color: #9b9b9b;
      }
      .serve_apply_content_item_pic {
        position: absolute;
        top: -1px;
        left: -6.7px;
        width: 68px;
        height: 20px;
        object-fit: contain;
      }
    }
  }
}
.sponsor_area {
  // height: 258px;
  height: 310px;
  background: #ffeae1;
  .container_wrap {
    width: 1240px;
    // height: 258px;
    height: 310px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .sponsor_area_item {
    // width: 335px;
    // height: 234px;
    width: 400px;
    height: 280px;
    &:hover {
      cursor: pointer;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.expert_tutor {
  background: #e5eeff;
  padding-top: 32px;
  padding-bottom: 32px;
  box-sizing: border-box;
  overflow: hidden;

  .container_wrap {
    width: 1240px;
    margin: 0 auto;
    &:nth-child(2) {
      margin-top: 32px;
    }
  }
  .expert_tutor_title {
    color: #1981ff;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-size: 24px;
    margin-bottom: 24px;
  }
  .expert_tutor_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .expert_tutor_content_item {
      width: 128px;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #666666;
      transition: all 0.2s;
      &:hover {
        transform: scale(1.02);
        cursor: pointer;
      }
      .expert_tutor_content_item_pic {
        width: 128px;
        height: 136px;
        border-radius: 4px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .expert_tutor_content_item_name {
        margin: 8px 0 2px 0;
        font-size: 14px;
        line-height: 20px;
      }
      .expert_tutor_content_item_post {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}

.suport_firm {
  background: #f9edce;
  padding-top: 32px;
  box-sizing: border-box;
  overflow: hidden;
  .container_wrap {
    width: 1240px;
    margin: 0 auto;
  }
  .suport_firm_title {
    color: #1981ff;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-size: 24px;
    margin-bottom: 24px;
  }
  .suport_firm_content {
    padding-bottom: 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    .suport_firm_content_item {
      width: 166px;
      height: 88px;
      margin-bottom: 16px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.2s;
        &:hover {
          transform: scale(1.04);
          cursor: pointer;
        }
      }
    }
  }
}


	.icon-duoshanghupc-daohuotongzhi {
	  font-size: 14px;
	  color: #fff;
	  padding: 0 5px 0 2px;
	  animation: shock 3s infinite ease;
	}
	@keyframes shock {
	  5%,
	  25%,
	  45% {
	    transform: rotate(8deg);
	  }
	  0%,
	  10%,
	  30%,
	  50% {
	    transform: rotate(-8deg);
	  }
	  15%,
	  35%,
	  55% {
	    transform: rotate(4deg);
	  }
	  20%,
	  40%,
	  60% {
	    transform: rotate(-4deg);
	  }
	  65%,
	  100% {
	    transform: rotate(0deg);
	  }
	}
	.service_num {
	  position: absolute;
	  transform: scale(0.7);
	  top: -6px;
	  left: 14px;
	  font-size: 10px;
	  background-color: #fff;
	  border-radius: 10px;
	  padding: 0 3px;
	  color: rgb(201, 18, 18);
	}
	.service_color:hover {
	  color: #000 !important;
	}


  .wrapper {
    height: 420px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    .banner {
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .category {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
      height: 100%;
    }
    .sort {
      width: 208px;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      padding: 14px 0;
      .item {
        height: 39px;
        padding: 0 21px;
        .name {
          width: 150px;
        }
        .iconfont {
          font-size: 10px;
        }
      }
    }
    .sortCon {
      width: 664px;
      height: 100%;
      background-color: #fff;
      box-shadow: 5px 1px 10px rgba(0, 0, 0, 0.2);
      border: 1px solid #f2f2f2;
      border-left: 0;
      border-right: 0;
      padding: 0 5px 20px 29px;
      .title {
        padding-bottom: 8px;
        border-bottom: 1px solid #f1f1f1;
        .font-color {
          padding-bottom: 8px;
          font-size: 16px;
          border-bottom: 2px solid #e93323;
        }
      }
      .erSort {
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 400px;
        .item {
          margin-top: 30px;
          width: 25%;

          &:hover {
            .name {
              color: #e93323;
            }
          }
          .name {
            color: #282828;
            margin-left: 14px;
            width: 82px;
          }
          .pictrue {
            width: 50px;
            height: 50px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }


  .classify {
    width: 1250px;
    .list {
      margin-top: 30px;
      .title {
        .name {
          font-size: 22px;
          color: #333333;
          font-weight: bold;
        }
        .more {
          width: 58px;
          height: 24px;
          border: 1px solid #c6c6c6;
          font-size: 12px;
          color: #818181;
          margin-right: 50px;
          cursor: pointer;
          .iconfont {
            font-size: 10px;
          }
        }
      }
      .itemOne {
        width: 468px;
        height: 340px;
        margin: 20px 20px 0 0;
        cursor: pointer;
        &:hover {
          box-shadow: 0 3px 20px rgba(0, 0, 0, 0.06);
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
      .item {
        box-sizing:border-box;
        width: 224px;
        height: 340px;
        background-color: #fff;
        padding: 16px;
        margin: 20px 20px 0 0;
        cursor: pointer;
        &:hover {
          box-shadow: 0 3px 20px rgba(0, 0, 0, 0.06);
        }

        .pictrue {
          width: 192px;
          height: 192px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .money {
          margin-top: 12px;
          .font-color {
            font-size: 22px;
            font-weight: bold;
          }
          .y_money {
            color: #aaaaaa;
            font-size: 12px;
            text-decoration: line-through;
            margin-left: 8px;
          }
          .label {
            width: 20px;
            height: 20px;
            background: linear-gradient(
              330deg,
              rgba(231, 85, 67, 0.15) 0%,
              rgba(244, 103, 83, 0.15) 100%
            );
            font-size: 12px;
            text-align: center;
            line-height: 20px;
          }
        }
        .name {
          margin-top: 8px;
          color: #5a5a5a;
          height: 37px;
        }
        .payment {
          font-size: 12px;
          color: #aaaaaa;
          margin-top: 10px;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// IndexPc.vue?6a59e3d0